// extracted by mini-css-extract-plugin
module.exports = {"v1kfq88":"v1kfq88"};